const AudiobooksHero = () => {
  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/98737630112accc0ed1887b2ee982b73.jpg"
          alt="Audiobooks Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className="w-16 h-16 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
          <i className="ri-headphone-line text-3xl text-white"></i>
        </div>
        <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-5 leading-tight">
          Listen to God's Word
        </h1>
        <p className="text-lg md:text-xl text-white/95 leading-relaxed max-w-3xl mx-auto">
          Experience Pastor Don's books in audio format. Perfect for your commute, quiet time, or whenever you need spiritual encouragement.
        </p>
      </div>
    </section>
  );
};

export default AudiobooksHero;
